export default __webpack_public_path__ + "31d2e3d2671fc3b7814036d9631285e6.svg";